import React, { useEffect, useState, useRef } from "react";
import { SwiperSlide } from "swiper/react";
import { Container } from "reactstrap";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "recompose";
import { getListOfArticles } from "../../../services/redux/articles/widget/reducer";
import "./Section.scss";
import Section from "./Section";
import "swiper/swiper.min.css";
import { useLinks } from "../../../services/helpers/links";
import { ArticlesCategories } from "../Articles/NewArticlesCategories";
import { Loader } from "../../common";
import { ArticleCardWrapper } from "../../common/Article/ArticleCardWrapper";
import { pressNavigation } from "../../../services/helpers/articles";
import { usePressArticles } from "../../../services/apiHooks/articles";
import { CarouselWrapper } from "./CarouselWrapper";

export const PressSectionCarousel = ({
  title,
  subtitle,
  allCategoriesLinkAnchor,
  className,
  isCarousel = true,
  articlesLimit = 8,
  background = "light", // "light" | "dark"
  showMoreLink = true,
  showCategories = true,
}) => {
  const [activePressCategory, setActivePressCategory] = useState({ id: 53 });
  const [press, setPress] = useState([]);
  const { pressArticles, isLoading } = usePressArticles();
  const swiper = useRef(null);

  const sliderOn = isCarousel || window.innerWidth < 1200;
  const { article: articleLink, press: pressLink } = useLinks();

  const {
    t,
    i18n: { language },
  } = useTranslation(["navigation", "articlesMeta", "globals"]);

  useEffect(() => {
    if (!press.length && pressArticles.length) {
      if (activePressCategory.id === 53) {
        setPress(pressArticles.slice(0, articlesLimit));
      } else
        setPress(
          pressArticles
            .slice(0, articlesLimit)
            .filter(article =>
              article.categories
                .map(({ id }) => id)
                .includes(activePressCategory.id)
            )
        );
    }
  }, [activePressCategory, pressArticles]);

  return (
    <div className={`Sections--${background}`}>
      <Container>
        <Section
          className={classNames(className, "has-categories")}
          title={title || <h2>{t("articlesMeta:categories.53")}</h2>}
          subtitle={subtitle}
        >
          <span>
            {(showCategories || showMoreLink) && (
              <div className="Sections__categories has-categories">
                {showCategories && (
                  <ArticlesCategories
                    articlesNav={pressNavigation(t, language)}
                    activeCategory={activePressCategory}
                    defaultCat={53}
                    sliceCat={false}
                    setActiveCategory={cat => {
                      setActivePressCategory(cat);
                    }}
                    allCategoriesTagLabel={t("articlesMeta:categories.all")}
                  />
                )}
                {!!press && showMoreLink && (
                  <Link to={pressLink} className="Sections__more">
                    {allCategoriesLinkAnchor || t("widgets:news.allArticles")}
                  </Link>
                )}
              </div>
            )}

            {isLoading ? (
              <Loader small />
            ) : (
              <CarouselWrapper
                slidesPerViewSmall={1}
                slidesPerViewMed={4}
                slidesPerViewBig={4}
                swiperRef={swiper}
                isSliderOn={sliderOn}
                showNav={press.length > 4 || window.innerWidth < 1200}
                showPag={press.length > 4 || window.innerWidth < 1200}
              >
                {!!press.length &&
                  press.map(el => {
                    return (
                      <SwiperSlide key={el.slug} style={{ height: "auto" }}>
                        <ArticleCardWrapper
                          article={el}
                          key={el.id}
                          id={el.id}
                        />
                      </SwiperSlide>
                    );
                  })}
              </CarouselWrapper>
            )}
          </span>
        </Section>
      </Container>
    </div>
  );
};

export default compose(
  withTranslation(["widgets", "urlsNames"]),
  connect(
    state => ({
      press: state.articles.articlesAll.results,
      pressTags: state.articles.articlesTags.results,
    }),
    dispatch => ({
      fetchArticlesAll: config => dispatch(getListOfArticles(config)),
    })
  )
)(PressSectionCarousel);
